import { render, staticRenderFns } from "./FavouriteUnselected.vue?vue&type=template&id=35a09839"
var script = {}
import style0 from "./FavouriteUnselected.vue?vue&type=style&index=0&id=35a09839&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports